<template>
  <div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h4>
                     تقييمات الطلاب
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div class="form-group">
                        <label for="">المعلم</label>
                        <select class="form-control" v-model="teacher" @change="filter()">
                            <option value="all">الكل</option>
                            <option v-for="t in teachers" :key="t" :value="t">
                                {{ t }}
                            </option>
                        </select>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="form-group">
                        <label for="">الفصل</label>
                        <select class="form-control" v-model="classroom" @change="filter()">
                            <option value="all">الكل</option>
                            <option v-for="t in classrooms" :key="t" :value="t">
                                {{ t }}
                            </option>
                        </select>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="form-group">
                        <label for="">بحث عن طالب</label>
                        <input class="form-control" placeholder="الاسم هنا..." v-model="name" @keyup="filter()">
                        </div>
                    </div>
                </div>
                <button class="btn btn-sm btn-primary" style="border-radius: 0px" @click="print()">
                    <i class="fa fa-print"></i> طباعة الجدول
                </button>
                <input type="date" v-model="date" style="border-radius: 0px; height: 28px; position: relative; top: 1px">
                <button class="btn btn-sm btn-success" style="border-radius: 0px" v-b-modal.send @click="f=rates.filter(function(x){
                    if(date == '' || x.date.includes(date)){
                        return x;
                    }
                    return false;
                })">
                    <i class="fa fa-paper-plane"></i> ارسال التقييمات المعروضة لأولياء الامور
                </button>
                <b-modal id="send" title="ارسال لأولياء الامور" hide-footer>
                    <div class="alert alert-warning g text-center">
                        <span class="text-dark">سيتم إرسال {{ f.length }} رسالة</span>
                        <br>
                        <small class="text-secondary">برجاء التأكد من اختيار تاريخ معين لإرسال تقييماته او اتركه فارغاً لإرسال الكل.</small>
                    </div>
                    <div class="form-group">
                      <h5 for="">الرسالة</h5>
                      <textarea class="form-control" placeholder="الرسالة هنا" v-model="message" rows="3"></textarea>
                    </div><div class="row">
            <div class="col-12 col-lg-6 g">
                <b-dropdown style="width: 100%"
                    id="dropdown-1" dropup size="lg"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                >
                    <template #button-content>
                        <i class="fa fa-whatsapp"></i>
                        واتساب
                    </template>
                    <b-dropdown-item @click="send('whatsapp')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-1.png')" style="width: 28px;">
                        واتساب تلقائي (الواتس الذكي)</span>
                    </b-dropdown-item>
                    <b-dropdown-item  @click="send('wa')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-2.png')" style="width: 28px;">
                            اداة المتصفح المجانية</span>
                    </b-dropdown-item>
                    <b-dropdown-item  @click="send('xwa')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-3.png')" style="width: 28px;">
                        الاداة المتطورة (الواتس المباشر) <i class="btn btn-danger" style="padding: 2px">جديد</i></span>
                    </b-dropdown-item>
                    <div class="text-center g">
                        <a href="/whats-methods" target="_blank">ما الفرق بينهم؟</a>
                    </div>
                </b-dropdown>
            </div>
            <div class="col-12 col-lg-6 g">
                <button class="btn btn-primary btn-block btn-lg"  @click="send('sms')">
                    <i class="fa fa-mobile"></i>
                    SMS
                </button>
                <button class="btn btn-outline-primary mt-50 btn-block btn-lg"  @click="send('push')">
                    <i class="fa fa-bell"></i>
                    إشعار الجوال
                </button>
            </div>
        </div>
                </b-modal>
                <div class="col-12 table-responsive" id="printme" style="padding: 0px">
                    <table class="table table-hover table-sm table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>
                                    الطالب
                                </th>
                                <th>
                                    المعلم
                                </th>
                                <th>
                                    التقييم
                                </th>
                                <th>
                                    التاريخ	
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="rate in rates">
                                <tr v-if="date == '' || rate.date.includes(date)" :key="rate._id">
                                    <td>
                                        {{ rate.student_name }}
                                    </td>
                                    <td>
                                        {{ rate.teacher_name }}
                                    </td>
                                    <td>
                                        {{ rate.content }}
                                    </td>
                                    <td>
                                        {{ rate.date }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput, BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
    components: {
        // Layouts
        BDropdown, BDropdownItem,
        vSelect,
        BModal,BFormInput},
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            rates: [],
            f: [],
            teachers: [],
            teacher: "all",
            classrooms: [],
            classroom: "all",
            students: [],
            message: `تم إضافة تقييم لإبنكم {name}
التقييم: {rate}
بتاريخ: {date}`,
            original: [],
            date: "",
            name: "",
            user: JSON.parse(localStorage.getItem('user')),
        }
    },
    created(){
        if(!checkPer("students|rates")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        g.getrates();
        $.post(api + '/user/students/list', {
            jwt: this.user.jwt,
            q: this.q,
            page: 1,
            perpage: 10000
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                g.students = r.response
            }
        }).fail(function(){
            g.loading = false;
        })
    },
    methods: {
        send(method){
            var g = this;
            var messages = [];
            g.f.forEach(function(a){
                var v = [];
                g.students.forEach(function(ax){
                    if(ax.number == a.number){
                        v = ax.phones
                    }
                })
                messages.push({
                    phones: v,
                    message: convertToHijri(g.message.replace("{name}", a.student_name).replace("{rate}", a.content).replace("{date}", a.date.split(' ')[0]))
                })
            })
            if(method == 'wa'){
                $("#sendmodalwaarray").val(JSON.stringify(messages))
                $("#sendmodalwatype").val("students")
                $("#sendWAModal").click()
                    $(".x345").removeClass('btn-success')
                    $(".x345").addClass('btn-outline-danger')
                    $(".x345").html("<i class='fa fa-refresh'></i> حدث الصفحة للارسال من الاداة مرة أخرى")
            }else{
                $.post(api + '/user/messages/send-arr', {
                    jwt: g.user.jwt,
                    arr: JSON.stringify(messages),
                    method: method,
                    type: "students"
                }).then(function(r){
                    g.loaded = true;
                    if(r.status != 100){
                        alert(r.response, 200)
                    }else{
                        alert("تم الارسال بنجاح٫ يمكنك تصفح ارشيف الرسائل", 100)
                    }
                }).fail(function(){
                    alert("حدث خطأ", 200)
                })
            }
        },
        print(){
            var g = this;
            var divToPrint=document.getElementById("printme");
            var newWin= window.open("");
            newWin.document.write(`
            <style>
            html, body{
                direction: rtl
            }
            .hidemonprint{
                display:none;   
            }
            table, td, th {
            border: 1px solid;
            }

            table {
            width: 100%;
            border-collapse: collapse;
            }
            </style>
            ` + divToPrint.innerHTML);
            newWin.document.close()
            newWin.print();
        },
        filter(){
            var g = this, arr = [];
            g.rates = g.original;
            g.rates.forEach(function(a){
                var add = false;
                if(g.teacher == a.teacher_name || g.teacher == "all"){
                    add = true;
                }
                if(g.classroom == a.classroom || g.classroom == "all"){
                    if(add){
                        add = true;
                    }
                }else{
                    add = false;
                }
                if(g.name != ""){
                    if(a.student_name.includes(g.name)){
                        add = true;
                    }else{
                        add = false;
                    }
                }
                if(add){
                    arr.push(a)
                }
            })
            g.rates = arr;
        },
        getrates(){
            var g = this;
            $.post(api + '/user/students/rates', {
                jwt: this.user.jwt,
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.rates = r.response;
                    g.original = r.response;
                    g.rates.forEach(function(a){
                        if(!g.classrooms.includes(a.classroom)){
                            g.classrooms.push(a.classroom)
                        }
                        if(!g.teachers.includes(a.teacher_name)){
                            g.teachers.push(a.teacher_name)
                        }
                    })
                }
            }).fail(function(){
                g.loading = false;
            })
        },
    }
}
</script>

<style>
@import url(https://cdnjs.cloudflare.com/ajax/libs/vue-select/3.10.0/vue-select.css);
#vs3__listbox{
    max-height: 150px !important;
    overflow: hidden !important;
}
</style>